import { Sort } from '@angular/material/sort';
import { ArticleFilters } from '../interfaces/query/article-filters.interface';
import { Article } from '../models/article.model';

export class AddAllArticles {
    static readonly type = '[AllArticles] AddAllArticles';

    constructor(public payload: Article[]) {}
}

export class SetAllArticles {
    static readonly type = '[AllArticles] SetAllArticles';

    constructor(public payload: Article[]) {}
}

export class UnsetAllArticles {
    static readonly type = '[AllArticles] UnsetAllArticles';
}

export class FetchAllArticles {
    static readonly type = '[AllArticles] FetchAllArticles';

    constructor(
        public payload?: {
            search: string;
            sortBy: string;
            sortOrder: string;
            pageSize: number;
            pageNumber: number;
            filters: ArticleFilters;
        }
    ) {}
}

export class FetchAllArticlesSuccess {
    static readonly type = '[AllArticles] FetchAllArticlesSuccess';

    constructor(public payload: Article[]) {}
}

export class FetchAllArticlesFailure {
    static readonly type = '[AllArticles] FetchAllArticlesFailure';
}

export class FetchAllArticlesOnScroll {
    static readonly type = '[AllArticles] FetchAllArticlesOnScroll';

    constructor(
        public payload?: {
            search: string;
            sortBy: string;
            sortOrder: string;
            sortLanguage: string;
            pageSize: number;
            pageNumber: number;
            postingType: string;
            onlyValid: boolean;
        }
    ) {}
}

export class FetchAllArticlesOnScrollSuccess {
    static readonly type = '[AllArticles] FetchAllArticlesOnScrollSuccess';

    constructor(public payload: Article[]) {}
}

export class FetchAllArticlesOnScrollFailure {
    static readonly type = '[AllArticles] FetchAllArticlesOnScrollFailure';
}

export class ToggleSelectedArticle {
    static readonly type = '[AllArticles] ToggleSelectedArticle';

    constructor(public payload: string) {}
}

export class SelectFilteredArticles {
    static readonly type = '[AllArticles] SelectFilteredArticles';
}

export class DeselectSelectedArticles {
    static readonly type = '[AllArticles] DeselectSelectedArticles';
}

export class SearchAllArticles {
    static readonly type = '[AllArticles] SearchAllArticles';

    constructor(public payload: string) {}
}

export class SortAllArticles {
    static readonly type = '[AllArticles] SortAllArticles';

    constructor(public payload: Sort) {}
}

export class SortOrderAllArticles {
    static readonly type = '[AllArticles] SortOrder';

    constructor(public payload: string) {}
}

export class SortByAllArticles {
    static readonly type = '[AllArticles] SortBy';

    constructor(public payload: string) {}
}

export class SortLanguageAllArticles {
    static readonly type = '[AllArticles] SortLanguage';

    constructor(public payload: string) {}
}
